import { useReducer, useMemo, useEffect } from "react";
import BraintreeStateContext from "./BraintreeStateContext";
import braintreeInitialState from "./BraintreeInitialState";
import brainTreeStateReducer from "./brainTreeStateReducer";
import requestClientParams from "./requestClientParams";

export function BraintreeProvider(props) {
  const { children, isKioskMode } = props;
  const [state, dispatch] = useReducer(brainTreeStateReducer, braintreeInitialState);
  const stateContextMemo = useMemo(() => {
    return {
      state,
      dispatch,
      setPayButtonStatus: (status) => {
        dispatch({ type: "SET_STATUS", payload: status });
      }
    };
  }, [state, dispatch]);

  useEffect(() => {
    if (isKioskMode) {
      dispatch({ type: "DISABLE_PAYPAL", payload: "disabled" });
      return;
    }

    // TODO: Include Retry Logic
    requestClientParams()
      .then((resp) => {
        dispatch({ type: "SET_CLIENT_TOKEN", payload: resp.clientToken });
      })
      .catch((error) => {
        console.log(error);
        stateContextMemo.setPayButtonStatus("error");
        dispatch({ type: "SET_ERROR", payload: error?.message || "unknown error" });
      });
  }, [isKioskMode]);

  return (
    <BraintreeStateContext.Provider value={stateContextMemo}>
      {children}
    </BraintreeStateContext.Provider>
  );
}
